import { motion } from "framer-motion";
import { PhoneFrame } from "@/components/AppScreens";

const SCREENS = [
    {
        key: "feed",
        label: "Accueil",
        src: "/screens/feed.jpeg",
        alt: "Écran d'accueil Coway — trajets disponibles autour de vous",
    },
    {
        key: "messages",
        label: "Messages",
        src: "/screens/messages.jpeg",
        alt: "Messagerie Coway — conversations avec les autres passagers",
    },
    {
        key: "chat",
        label: "Chat",
        src: "/screens/chat.jpeg",
        alt: "Conversation chiffrée entre passagers Coway",
    },
    {
        key: "profile",
        label: "Profil",
        src: "/screens/profile.jpeg",
        alt: "Profil utilisateur vérifié Coway avec note 4.9",
    },
    {
        key: "reviews",
        label: "Avis & impact",
        src: "/screens/reviews.jpeg",
        alt: "Statistiques utilisateur Coway — avis et CO₂ évité",
    },
];

export default function Screenshots() {
    return (
        <section
            data-testid="screenshots-section"
            className="relative py-24 lg:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_50%,rgba(81,199,173,0.05),transparent_70%)]" />
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <div className="max-w-2xl">
                        <p className="text-xs text-coway uppercase tracking-[0.3em] font-semibold mb-5">
                            L'app
                        </p>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-slate-900">
                            Pensée pour aller
                            <br />
                            <span className="text-slate-400">droit au but.</span>
                        </h2>
                    </div>
                    <p className="text-base lg:text-lg text-slate-600 max-w-sm">
                        Un design mobile-first : trouver un trajet, discuter,
                        partager les frais — en quelques taps, depuis n'importe
                        où.
                    </p>
                </div>
            </div>

            {/* Horizontal scrollable carousel — real app screenshots */}
            <div data-testid="screens-carousel" className="relative">
                <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory px-6 lg:px-12 pb-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                    {SCREENS.map((s, i) => (
                        <div
                            key={s.key}
                            data-testid={`screen-${s.key}`}
                            className={`snap-center shrink-0 ${i % 2 === 0 ? "md:translate-y-4" : "md:-translate-y-4"}`}
                        >
                            <div className="flex flex-col items-center gap-3">
                                <PhoneFrame src={s.src} alt={s.alt} />
                                <motion.span
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                    className="text-xs uppercase tracking-[0.25em] text-slate-500 font-semibold"
                                >
                                    {s.label}
                                </motion.span>
                            </div>
                        </div>
                    ))}
                    <div className="shrink-0 w-6" aria-hidden />
                </div>

                <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-background to-transparent hidden md:block" />
                <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-background to-transparent hidden md:block" />
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-10 flex items-center justify-center gap-2">
                <span className="w-2 h-2 rounded-full bg-coway animate-pulse" />
                <p className="text-xs text-slate-500 uppercase tracking-[0.25em] font-semibold">
                    Faites défiler pour explorer l'app
                </p>
            </div>
        </section>
    );
}
